// import { ExclamationCircleOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Switch, SwitchProps } from 'antd';
// import { useMemo } from 'react';

const styles = {
  title: css`
    display: inline-block;
    min-width: 80px;
    font-size: 16px;
    color: #515359;
    margin-right: 24px;
  `,
  tip: css`
    font-size: 12px;
    color: #84868c;
    margin-left: 16px;
  `,
  icon: css`
    margin-right: 6px;
    color: #faad14;
  `,
};

interface Props extends SwitchProps {
  title?: string;
  value?: boolean;
  tip?: string | ((checked: boolean) => React.ReactNode);
}

const SwitchWithText = (props: Props) => {
  const { title, value, tip, onChange, ...switchProps } = props;
  // const ttip = useMemo(() => {
  //   if (typeof tip === 'function') {
  //     return tip(value || false);
  //   }
  //   return tip;
  // }, [value, tip]);
  return (
    <div>
      {title && <span className={styles.title}>{title}</span>}
      <Switch
        checkedChildren="启用中"
        unCheckedChildren="已关闭"
        checked={value}
        onChange={onChange}
        {...switchProps}
      />
      {/* <span className={styles.tip}>
        <ExclamationCircleOutlined className={styles.icon} />
        {ttip && <span>{ttip}</span>}
      </span> */}
    </div>
  );
};

export default SwitchWithText;
